import { createStyles, Theme } from "@material-ui/core/styles";
import { container } from "../../assets/jss/material-kit-pro-react";

export const styles: any = (theme: Theme) =>
  createStyles({
    container,
    root: {
      ...container,
      height: "100%",
      width: "100%",
    },
    screenSize: {
      [theme.breakpoints.down("md")]: {
        height: 500,
      },
      height: "100%"
    },
  });
